import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M14 4.504l-1.333 1.334V2.666h-6V6H3.333v7.333h9.334v-1.838L14 10.162v3.843a.662.662 0 01-.662.661H2.662A.666.666 0 012 13.995V5.333l4.002-4h7.33a.67.67 0 01.668.661v2.51zm.519 1.367l.942.943L10.276 12l-.944-.002.001-.941 5.186-5.185V5.87z'
      ></path>
    </svg>
  )
}

export default Icon
